import React from 'react';
import classnames from 'classnames';
import HtmlContent from './HtmlContent';

import {
    componentMissmatchWarning,
    layoutClasses,
} from './helpers';

import {
    SECTION_OVERVIEW,
    COMPONENT_HTML,
} from './constants';

class OverviewSection extends React.Component {

    renderComponent(component, index) {
        const { type, content } = component;
        switch (type) {
        case COMPONENT_HTML:
            return (
                <HtmlContent
                    key={index}
                    className="overview__content mb-4"
                    html={content.html}
                />
            );
        default:
            return componentMissmatchWarning(type, SECTION_OVERVIEW);
        }
    }

    render() {
        const { className, components, layout } = this.props;
        const classes = classnames('section--overview', className, layoutClasses(layout));

        // Fail silently if no components
        if (!components) return null;

        return (
            <div className={classes}>
                {components.map(this.renderComponent)}
            </div>
        );
    }
}

export default OverviewSection;
